import styled from "styled-components"

import { spacing } from "@minuthq/meatball-ui-react"

import { usePostIntegrationConnectInitiated } from "src/data/analytics/queries/integrationAnalyticsQueries"
import { findBrokenConnection } from "src/data/integrations/logic/integrations"
import { TIntegration } from "src/data/integrations/types/integrationTypes"
import { useTranslate } from "src/i18n/useTranslate"
import { MButton } from "src/ui/Button/MButton"
import { ConfirmDialog } from "src/ui/Dialog/ConfirmDialog"

export function ConfirmDisconnectDialog({
  name,
  integration,
  open,
  onClose,
  onConfirm,
  loading,
  setShowReconnectDialog,
}: {
  name: string
  integration: TIntegration
  open: boolean
  loading: boolean
  onClose: () => void
  onConfirm: () => void
  setShowReconnectDialog: (value: boolean) => void
}) {
  const { t, langKeys } = useTranslate()

  const postIntegrationConnectInitiated = usePostIntegrationConnectInitiated()

  function handleClose() {
    onClose()
  }

  function handleConfirm() {
    onConfirm()
  }

  function handleReconnectClick() {
    handleClose()
    setShowReconnectDialog(true)
    postIntegrationConnectInitiated.mutate({
      integration_name: integration.name,
      reconnect: true,
    })
  }

  return (
    <>
      <ConfirmDialog
        title={`${t(langKeys.integrations_disconnect_confirm_title, {
          integration: name,
        })}`}
        description={
          <DialogDesciption
            integration={integration}
            onReconnectClick={handleReconnectClick}
          />
        }
        confirmButtonProps={{
          color: "destructive",
        }}
        confirmLabel={t(langKeys.disconnect)}
        open={open}
        onClose={handleClose}
        onConfirm={handleConfirm}
        loading={loading}
        autoFocus={false}
      />
    </>
  )
}

function DialogDesciption({
  integration,
  onReconnectClick,
}: {
  integration: TIntegration
  onReconnectClick: () => void
}) {
  const { t, langKeys } = useTranslate()

  const brokenIntegration = findBrokenConnection(integration)

  const mainText =
    integration.integration_identifier === "airbnb"
      ? t(langKeys.integrations_disconnect_confirm_body_airbnb)
      : t(langKeys.integrations_disconnect_confirm_body)

  return (
    <DescriptionBox>
      <div>{mainText}</div>

      {!!brokenIntegration && (
        <div>
          {t(langKeys.integrations_fix_broken_integrations)},{" "}
          <MButton onClick={onReconnectClick} variant="minimal">
            {t(langKeys.try_reconnecting).toLowerCase()}
          </MButton>
        </div>
      )}
    </DescriptionBox>
  )
}

const DescriptionBox = styled.div`
  display: grid;
  gap: ${spacing.L};
`
